import { Component, NgZone, OnDestroy, OnInit, ViewChild, } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IAngularMyDpOptions, IMyDateModel } from 'angular-mydatepicker';
import { ModalComponent, ModalConfig } from '../modal/modal.component';
import { ShipmentService } from '../services/shipment.service';
import * as moment from 'moment'
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { take } from 'rxjs/internal/operators/take';
import { StorageService } from '../services/local-storage.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { customValidator } from '../services/utils/customValidation';


@Component({
  selector: 'app-shipment',
  templateUrl: './shipment.component.html',
  styleUrls: ['./shipment.component.css']
})
export class ShipmentComponent implements OnDestroy, OnInit {
  data;
  modalConfig: ModalConfig = { modalTitle: "" };
  @ViewChild('modal') private modalComponent: ModalComponent
  dtOptions: any = {};
  dtOptionsAudit: any = {};
  countries = []
  ctrl_ens_result = []
  ctrl_ens = []
  shipmentSelected: any;
  formEdit: FormGroup;
  formFilters: FormGroup;
  filtersActive: boolean = false;
  showCollapse: boolean = true
  modalAudit: boolean = false
  @ViewChild(DataTableDirective, { static: false })
  private datatableElement: DataTableDirective;
  dtTrigger: Subject<any>;
  shipmentRowIndex: number
  myDatePickerOptions: IAngularMyDpOptions = {
    dateRange: true,
    rtl: false,
    dateFormat: "dd/mm/yyyy"
  }
  datatableLanguge: any;
  ctrl_ens_select: any;
  auditData: any = []
  ctrl_h7: any = []
  packetStatusUpdated_select: any = []
  packet_StatusUpdated: any = []
  ctrl_h7_select: any = []

  /*  observable = from(this.filtersActive); */
  constructor(private formBuilder: FormBuilder, public shipmentService: ShipmentService,
    private zone: NgZone, public storage: StorageService, private translate: TranslateService,) {
    this.dtTrigger = new Subject()

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.dtOptions.language = event.translations.dataTable
      if (this.filtersActive) {
        this.render(this.data)
      }
    });
  }


  ngOnInit(): void {

    this.shipmentService.getData().then(res => {
      this.countries = res.response.country
      this.ctrl_ens_select = res.response.controlEns
      this.ctrl_h7_select = res.response.controlEns
      this.ctrl_ens_result = res.response.controlResult
      this.packetStatusUpdated_select=res.response.packetStatusUpdated

      console.log({packetStatusUpdated_select: this.packetStatusUpdated_select})
    });

    this.translate.get("dataTable").subscribe((language) => {
      this.datatableLanguge = language

      this.dtOptionsAudit = {

        destroy: true,
        scrollY: "250px",
        scrollX: true,
        scrollCollapse: true,
        ordering: false,
        paging: false,
        searching: false,
        info: false,
        "columnDefs": [
          { targets: [0], width: "150px" },
          { targets: [3], width: "150px" },
          { targets: [4], width: "150px" },
          { targets: [5], width: "135px" },
          { targets: [6], width: "135px" },
          { targets: [7], width: "135px" },
          { targets: '_all', width: "90px" }
        ], language: this.datatableLanguge
      };

      this.dtOptions = {
        responsive: false,
        retrieve: true,
        destroy: true,
        info: false,
        order: [[1, "asc"]],
        columnDefs: [{ targets: [0], orderable: false, searchable: false }],
        language: this.datatableLanguge,
        dom: "<'row'<'col-6 asasa'><'col-6'fB>>" +
          "<'row'<'col-12 mt-5 mb-5'tr>>" +
          "<'row'<'col-3'i><'col-6'p> <'col-3'l>>",
        buttons: [
          {
            text: '<i class="icon-excel"></i>',
            key: '1',
            titleAttr: 'excel',
            extend: 'excel'
          }
        ]
      };

    });

    this.data = []
    this.auditData = []
    this.formEdit = this.formBuilder.group(
      {
        ctrl_ens: [
          '', Validators.required],
        ctrl_ens_result: [
          '', Validators.required
        ],
        controlH7: ['', Validators.required],
        packetStatusUpdated: ['', Validators.required],
        comments: [
          '', Validators.required
        ],

      }
    );

    this.formFilters = this.formBuilder.group(
      {
        dateFilter: [
          null],
        shipment_num: [
          ''
        ],
        statusSelect: [
          ''
        ],
        countrySelect: [
          ''
        ],

      }, {
      validator: customValidator.validationFilters
    }
    );
  }

  setDate(): void {
    // Set today date using the patchValue function
    let model: IMyDateModel = { isRange: false, singleDate: { jsDate: new Date() }, dateRange: null };
    this.formFilters.patchValue({ myDate: model });
  }

  clearDate(): void {
    // Clear the date using the patchValue function
    this.formFilters.patchValue({ myDate: null });
  }
  async openEdit(shipment, index) {  
  
    this.modalAudit = false
    this.shipmentSelected = shipment;
    this.shipmentRowIndex = index
    this.ctrl_ens = this.ctrl_ens_select
    this.ctrl_h7 = this.ctrl_h7_select
    this.packet_StatusUpdated=this.packetStatusUpdated_select

    this.formEdit.controls['ctrl_ens'].setValue(shipment.controlEns.toUpperCase());
    this.formEdit.controls['ctrl_ens_result'].setValue(shipment.controlResultEns.toUpperCase());
    this.formEdit.controls['comments'].setValue(shipment.annotations);
    this.formEdit.controls['controlH7'].setValue(shipment.controlH7);
    this.formEdit.controls['packetStatusUpdated'].setValue(shipment.packetStatusUpdated);
    console.log('shipment',shipment);
    console.log('this.packetStatusUpdated_select',this.packetStatusUpdated_select);
    
    if (shipment.controlEns.toUpperCase() === 'GREEN') {
      this.ctrl_ens = this.ctrl_ens_select.filter(item => item.description.toUpperCase() != null)
    } else if (shipment.controlEns.toUpperCase() === 'ORANGE') {
      this.ctrl_ens = this.ctrl_ens_select.filter(item => item.description.toUpperCase() != 'GREEN')

    } else {
      this.ctrl_ens = this.ctrl_ens_select.filter(item => (item.description.toUpperCase() != 'GREEN' && item.description.toUpperCase() != 'ORANGE'))
    }

    if (shipment.controlH7.toUpperCase() === 'GREEN') {
      this.ctrl_h7 = this.ctrl_h7_select.filter(item => item.description.toUpperCase() != null)
    } else if (shipment.controlH7.toUpperCase() === 'ORANGE') {
      this.ctrl_h7 = this.ctrl_h7_select.filter(item => item.description.toUpperCase() != 'GREEN')

    } else {
      this.ctrl_h7 = this.ctrl_h7_select.filter(item => (item.description.toUpperCase() != 'GREEN' && item.description.toUpperCase() != 'ORANGE'))
    }  
    
    if (shipment.packetStatusUpdated.toUpperCase() === 'AUTO') {
      this.packet_StatusUpdated = this.packetStatusUpdated_select.filter(item => item.description.toUpperCase() != null)
    } else if (shipment.controlH7.toUpperCase() === 'ORANGE') {
      this.ctrl_h7 = this.ctrl_h7_select.filter(item => item.description.toUpperCase() != 'GREEN')

    } else {
      this.ctrl_h7 = this.ctrl_h7_select.filter(item => (item.description.toUpperCase() != 'GREEN' && item.description.toUpperCase() != 'ORANGE'))
    }  

    this.translate.get("shipment").subscribe((text) => {
      this.modalConfig.modalTitle = text.editTitle
      this.modalConfig.modalSubTitle = text.editSubtitle

    });

    return await this.modalComponent.open()
  }
  hideButton(): boolean {
    return true
  }
  async editShipment() {

    var userName = this.storage.getCurrentUser().userName
    var body = {
      "shipmentId": this.shipmentSelected.id,
      "controlResultEns": this.formEdit.value.ctrl_ens_result,
      "controlEns": this.formEdit.value.ctrl_ens,
      "controlH7": this.formEdit.value.controlH7,
      "packetStatusUpdated": this.formEdit.value.packetStatusUpdated,
      "annotations": this.formEdit.value.comments,
      "userUpdate": userName

    }

    this.shipmentService.editShipment(body).then(res => {
      this.shipmentSelected.controlResultEns = this.formEdit.value.ctrl_ens_result
      this.shipmentSelected.controlEns = this.formEdit.value.ctrl_ens;
      this.shipmentSelected.annotations = this.formEdit.value.comments;
      this.shipmentSelected.controlH7 = this.formEdit.value.controlH7;
      this.shipmentSelected.packetStatusUpdated = this.formEdit.value.packetStatusUpdated;

      this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      
 

           dtInstance.cell({ row: this.shipmentRowIndex, column: 11 }).data(this.shipmentSelected.annotations).draw()
           dtInstance.cell({ row: this.shipmentRowIndex, column: 16 }).data( this.shipmentSelected.controlResultEns).draw()
           dtInstance.cell({ row: this.shipmentRowIndex, column: 15 }).data( this.shipmentSelected.controlH7).draw()
 
        /*  dtInstance.row(this.shipmentRowIndex).data(this.formEdit.value.controlH7)[15].draw(true)
         dtInstance.row(this.shipmentRowIndex).data(this.formEdit.value.ctrl_ens_result)[16].draw(true) */
        //dtInstance.row(this.shipmentRowIndex).data(this.shipmentSelected).draw(true)


      })

      this.formEdit.reset();
      return this.modalComponent.dismiss()
    }).catch(err => {
      return this.modalComponent.dismiss()
    })

  }

  resetFilters() {

    this.zone.onMicrotaskEmpty.asObservable().pipe(
      take(1)
    ).subscribe(() => {

      this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.data = []
        this.filtersActive = false
      })
    });

  }
  async search() {
    let dateStart = ""
    let dateEnd = ""
    this.data = []
    if (this.formFilters.value.dateFilter) {
      dateStart = moment.unix(this.formFilters.value.dateFilter.dateRange.beginEpoc).format("YYYY-MM-DDTHH:mm:ss")
      dateEnd = moment.unix(this.formFilters.value.dateFilter.dateRange.endEpoc).format("YYYY-MM-DDTHH:mm:ss")
    }
    let filters = {
      "ShipmentNumber": this.formFilters.value.shipment_num || '',
      "DateIni": dateStart,
      "DateFin": dateEnd,
      "Nmaw": this.formFilters.value.statusSelect || '',
      "cpai": this.formFilters.value.countrySelect || '',
    }

    let lng = this.translate.currentLang == undefined ? 'en' : this.translate.currentLang;

    this.shipmentService.getShipment(filters, lng).then(res => {

      this.showCollapse = false      

      if (this.dtTrigger.observers == null) {
        this.dtTrigger = new Subject()
        this.filtersActive = true

        this.zone.onMicrotaskEmpty.asObservable().pipe(
          take(1)
        ).subscribe(() => {

          this.dtTrigger.next()
          this.data = res.response
        });

        return
      }
      if (this.dtTrigger.observers != null && !this.filtersActive) {

        this.filtersActive = true


        this.zone.onMicrotaskEmpty.asObservable().pipe(
          take(1)
        ).subscribe(() => {

          this.dtTrigger.next()

          this.data = res.response
        });
      } else {

        this.render(res.response)
      }
    })

  }
  render(data) {
    this.zone.onMicrotaskEmpty.asObservable().pipe(
      take(1)
    ).subscribe(() => {

      this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.clear();
        dtInstance.destroy();
        this.dtTrigger.next();
        this.data = data

      })

    });
  }
  async openAudit(shipment) {
    this.modalAudit = false
    this.shipmentSelected = shipment;
    this.translate.get("audit").subscribe((text) => {
      this.modalConfig.modalTitle = text.auditTitle
      this.modalConfig.modalSubTitle = this.shipmentSelected.shipmentNumber + '<span class="pill-modal pill pill-' + shipment.controlEns.toLowerCase() + '">' + shipment.controlEns + '</span>'

    });
    this.shipmentService.getAudit({ shipmentId: shipment.id }).then(res => {

      this.auditData = res.response.logs || []
      this.modalAudit = true

      return this.modalComponent.open()

    })


  }
  ngAfterViewInit() {
    this.dtTrigger.next();

  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }
}
